type LocationParts = Pick<Location, 'hash' | 'pathname' | 'search'>;

const DEFAULT_AUTH_REDIRECT_URL = '/';

export const getCurrentAuthRedirectUrl = (location?: LocationParts): string => {
  if (!location) {
    return DEFAULT_AUTH_REDIRECT_URL;
  }

  const pathname = location.pathname || DEFAULT_AUTH_REDIRECT_URL;
  const normalizedPathname = pathname.startsWith('/') ? pathname : `/${pathname}`;

  return `${normalizedPathname}${location.search || ''}${location.hash || ''}`;
};
